import React, { useState, useRef, useEffect } from "react";
import "../../styles/faqs.css";

export default function FAQsSection({ college }) {
  const [openIndex, setOpenIndex] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const faqsListRef = useRef(null);

  // ✅ Move useEffect BEFORE the early return
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (faqsListRef.current) {
      observer.observe(faqsListRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // ✅ Early return AFTER all hooks
  if (!college?.faqs || college.faqs.length === 0) {
    return null;
  }

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faqs-section">
      <div className="faqs-container">
        <h2 className="faqs-title">Frequently Asked Questions</h2>

        <div 
          className={`faqs-list ${isVisible ? 'animate-in' : ''}`}
          ref={faqsListRef}
        >
          {college.faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              style={{ "--delay": `${index * 0.1}s` }}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-number">{index + 1}</span>
                <span className="faq-text">{faq.question}</span>
                <span className="faq-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </button>
              
              <div className="faq-answer">
                <div className="faq-answer-content">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
